"use client";

import ComingSoonClient from "@/app/coming-soon/ComingSoonClient";

export default function TechnologySaasPage() {
  return <ComingSoonClient />;
}


